import { render, staticRenderFns } from "./NotificationPointItemParts.vue?vue&type=template&id=3898d4d6&scoped=true"
import script from "./NotificationPointItemParts.vue?vue&type=script&lang=ts"
export * from "./NotificationPointItemParts.vue?vue&type=script&lang=ts"
import style0 from "./NotificationPointItemParts.vue?vue&type=style&index=0&id=3898d4d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3898d4d6",
  null
  
)

export default component.exports